import React, { memo } from "react";

const statusConfig = {
  Sales: { variant: "success", icon: "bi-currency-dollar" },
  "Not Interested": { variant: "warning", icon: "bi-x-circle" },
  "Not Qualified": { variant: "secondary", icon: "bi-slash-circle" },
  DNC: { variant: "danger", icon: "bi-telephone-x" },
  Voicemail: { variant: "info", icon: "bi-mic" },
  "Tech Issues": { variant: "danger", icon: "bi-wrench" },
  DWSPI: { variant: "secondary", icon: "bi-shield-exclamation" },
  Unresponsive: { variant: "warning", icon: "bi-volume-mute" },
  Hungup: { variant: "danger", icon: "bi-telephone-minus" },
  "Dead Air": { variant: "dark", icon: "bi-mic-mute" },
  Callback: { variant: "primary", icon: "bi-telephone-plus" },
  IVR: { variant: "info", icon: "bi-robot" },
  "subsidy/incentivised": { variant: "success", icon: "bi-award" },
  "Language Barrier": { variant: "warning", icon: "bi-translate" },
  Misdialed: { variant: "secondary", icon: "bi-telephone-outbound" },
  income: { variant: "secondary", icon: "bi-telephone-outbound" },
  default: { variant: "light", icon: "bi-question-circle" },
};
const textColorMap = {
  primary: "var(--text-primary)",
  secondary: "var(--text-primary)",
  success: "var(--text-primary)",
  danger: "var(--text-primary)",
  warning: "black",
  info: "var(--text-primary)",
  light: "black",
  dark: "var(--text-primary)",
};

const StatusBadge = memo(({ status, showIcon = true, size = "sm" }) => {
  if (!status || typeof status !== "string") return null;

  const config = statusConfig[status] || statusConfig.default;
  const textColor = textColorMap[config.variant] || "var(--text-primary)";

  return (
    <span
      className={`badge bg-${config.variant} ${size === "lg" ? "badge-lg" : ""}`}
      style={{ color: textColor }}
    >
      {showIcon && <i className={`bi ${config.icon} me-1`} />}
      {status}
    </span>
  );
});

StatusBadge.displayName = "StatusBadge";

// Pipeline stage (CallRecord.callStatus), not to be confused with the QC
// disposition StatusBadge above - a call sits in one of these while it's
// still being transcribed/analyzed, before it ever gets a disposition.
const processingStatusConfig = {
  queued: { variant: "secondary", icon: "bi-hourglass-split", label: "Queued" },
  processing: { variant: "info", icon: "bi-gear", label: "Processing" },
  transcribing: { variant: "info", icon: "bi-mic", label: "Transcribing" },
  labeling_speakers: { variant: "info", icon: "bi-people", label: "Labeling Speakers" },
  analyzing_disposition: { variant: "info", icon: "bi-cpu", label: "Analyzing" },
  completed: { variant: "success", icon: "bi-check-circle", label: "Completed" },
  failed: { variant: "danger", icon: "bi-x-circle", label: "Failed" },
  transcription_failed: { variant: "danger", icon: "bi-x-circle", label: "Transcription Failed" },
  labeling_failed: { variant: "danger", icon: "bi-x-circle", label: "Labeling Failed" },
  analysis_failed: { variant: "danger", icon: "bi-x-circle", label: "Analysis Failed" },
  default: { variant: "light", icon: "bi-question-circle", label: null },
};

export const ProcessingStatusBadge = memo(({ status, showIcon = true, size = "sm" }) => {
  if (!status || typeof status !== "string") return null;

  const config = processingStatusConfig[status] || processingStatusConfig.default;
  const textColor = textColorMap[config.variant] || "var(--text-primary)";
  const isActive = ["processing", "transcribing", "labeling_speakers", "analyzing_disposition"].includes(
    status
  );

  return (
    <span
      className={`badge bg-${config.variant} ${size === "lg" ? "badge-lg" : ""}`}
      style={{ color: textColor }}
    >
      {showIcon && <i className={`bi ${config.icon} me-1 ${isActive ? "spin" : ""}`} />}
      {config.label || status}
    </span>
  );
});

ProcessingStatusBadge.displayName = "ProcessingStatusBadge";

export default StatusBadge;
